<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("maintenance_report")}}</h4>
                <p class="text-subtitle-1">{{$t("maintenance_report_subtitle")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-form ref="form">
            <v-row >
                <v-col>
                    <DatePicker
                        :label="$t('date_from')"
                        v-model="form.from"
                        outlined
                        dense
                        :rules="[isRequired]"
                        hide-details="auto"/>
                </v-col>
                <v-col>
                    <DatePicker
                        :label="$t('date_to')"
                        v-model="form.to"
                        outlined
                        :rules="[isRequired]"
                        dense
                        hide-details="auto"/>
                </v-col>
                <v-col>
                    <v-autocomplete
                        :label="$t('WORKSHOP_NAME')"
                        v-model="form.workshop_id"
                        :items="workshops"
                        item-value="id"
                        item-text="name"
                        outlined
                        dense
                        hide-details="auto"
                        :loading="workshopsLoading"
                        :rules="[isRequired]"
                        >
                    </v-autocomplete>
                </v-col>
                <v-col>
                    <v-btn block color="primary" @click="fetchAsync" :loading="loading">
                        <v-icon left>mdi-magnify</v-icon>
                        {{ $t("search") }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>

        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('filter')"
                    prepend-inner-icon="mdi-filter"
                    v-model="filter"
                    filled
                    shaped
                    dense
                    single-line
                    hide-details="auto"
                    clearable>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-progress-linear indeterminate v-if="loading"/>
                <v-simple-table dense ref="data">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{{$t("JOB_NUMBER")}}</th>
                            <th>{{$t("truck_type")}}</th>
                            <th>{{$t("plate_number")}}</th>
                            <th>{{$t("ENTER_DATE")}}</th>
                            <th>{{$t("Odometer")}}</th>
                            <th>{{$t("FAILURES")}}</th>
                            <th>{{$t("maintenance_performed")}}</th>
                            <th>{{$t("JOBCARD_LEAVE_DATE")}}</th>
                            <th>{{$t("idle_time")}}</th>
                            <th>{{$t("MALFACTION_CLASSFICATION")}}</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in filteredData" :key="i" @dblclick="openJobCardDisplayDialog(d.jobcard_id)">
                            <td>{{ i + 1 }}</td>
                            <td>{{ d.jobcard_code }}</td>
                            <td>{{ d.truck_type }}</td>
                            <td>{{ d.plate_number }}</td>
                            <td>{{ d.entered_at }}</td>
                            <td>{{ d.odometer }}</td>
                            <td class="text-pre-wrap">{{ d.failure }}</td>
                            <td class="text-pre-wrap">{{ d.maintenance }}</td>
                            <td>{{ d.leave_at }}</td>
                            <td>{{ formatNumber(d.duration_hours, 1) }}</td>
                            <td class="text-pre-wrap">{{ d.malfaction }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <JobcardDisplayDialog
            ref="jobcardDisplayDialog"/>
    </div>
</template>

<script>
import JobcardDisplayDialog from '../components/JobcardDisplayDialog.vue';
import { isRequired } from './../utils/validations.js'
import { maintenanceReport } from './../services/reports';
import workshopsAPI from './../services/workshop';
import DatePicker from './../components/DatePicker.vue';
import moment from 'moment';
import { formatNumber } from 'accounting';

export default {
    components: {
        DatePicker,
        JobcardDisplayDialog
    },
    data: () => {
        return {
            data: [],
            loading: false,
            form: {
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
                workshop_id: null
            },
            workshops: [],
            workshopsLoading: false,
            filter: "",
            isRequired,
        }
    },
    computed: {
        filteredData() {
            if(!this.filter || this.filter == "") return this.data;
            return this.data.filter(each => JSON.stringify(each).toLowerCase().indexOf(this.filter.toLowerCase()) != -1)
        }
    },
    methods: {
        formatNumber,
        async fetchAsync() {
            try {
                if(!this.$refs.form.validate()) return;
                this.data = [];
                this.loading = true;
                let res = await maintenanceReport(this.form);
                this.data = res.data;
                this.loading = false;
            } catch {
                this.loading = false;
            }
        },
        async fetchWorkshopsAsync() {
            try {
                this.workshopsLoading = true;
                let res = await workshopsAPI.index();
                this.workshops = res.data;
                this.workshopsLoading = false;
            } catch {
                this.workshopsLoading = false;
            }
        },
        openJobCardDisplayDialog(id) {
            this.$refs.jobcardDisplayDialog.open({id: id})
        }
    },
    created() {
        this.fetchWorkshopsAsync();
    }
};
</script>

<style></style>
